// Export all configuration modules
export { config, validateConfig, isDevelopment, isProduction, isStaging } from './environment'
export { environments, getEnvironmentSettings } from './environments'
export { FeatureFlags } from './features'
export { getApiConfig, API_ENDPOINTS, buildApiUrl, buildWsUrl, RATE_LIMITS, TIMEOUTS } from './api'

// Initialize feature flags on import
import { FeatureFlags } from './features'
FeatureFlags.initialize()